module.exports = __webpack_public_path__ + "static/media/pf.3ac8d5bd.svg";